import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

export const getTraderUnitById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_TRADER_UNIT_BY_ID}?Id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getTraderUnitListByTraderId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_TRADER_UNIT_BY_TRADERID}?userId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const getActiveDocumentsByUnitId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_ACTIVE_UNIT_DOCUMENTS_BY_UNIT_ID}?unitId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const getActiveShopFrontsByUnitId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_ACTIVE_UNIT_SHOPFRONTS_BY_UNIT_ID}?unitId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const getActiveUnitListByTraderId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_ACTIVE_UNIT_BY_TRADERID}?userId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const updateTraderUnit = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.UPDTAE_TRADER_UNIT,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const uploadTraderUnitImage = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true, true));
    const response = await axioClient.post(
      apiendpoints.UPLOAD_TRADER_UNIT_IMAGE,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const setSelectedTraderUnit = (traderunit) => {
  localStorage.setItem("selectedTraderUnit", JSON.stringify(traderunit));
};

export const getSelectedTraderUnit = () => {
  const selectedTraderUnit = localStorage.getItem("selectedTraderUnit");
  if (selectedTraderUnit !== null && selectedTraderUnit !== undefined) {
    return JSON.parse(selectedTraderUnit);
  } else {
    return null;
  }
};

export const removeSelectedTraderUnit = () => {
  localStorage.removeItem("selectedTraderUnit");
};

export const getTraderUnitDocumentById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_TRADER_UNIT_DOCUMENT_BY_ID}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//Event_by_id
export const getDocumentByTraderUnitId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_TRADER_UNIT_DOCUMENT_BY_UNIT_ID}?unitId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//Event_Document_Update
export const updateTraderUnitDocument = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true, true));
    const response = await axioClient.post(
      apiendpoints.UPDATE_TRADER_UNIT_DOCUMENT,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getTraderUnitShopfront = async (traderid, unitid, isAvailable) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true, true));
    const response = await axioClient.get(
      `${apiendpoints.GET_TRADER_UNIT_SHOPFRONT}?traderId=${traderid}&unitId=${unitid}&isAvailable=${isAvailable}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const addTraderUnitShopfront = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.ADD_TRADER_UNIT_SHOPFRONT,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const deleteTraderUnitShopfront = async (unitId, productId) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.DELETE_TRADER_UNIT_SHOPFRONT}?unitId=${unitId}&productId=${productId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// Event_Document_Delete
export const deleteTraderUnitDocument = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.DELETE_TRADER_UNIT_DOCUMENT}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// export const setDocumentId = (id) => {
//   localStorage.setItem("traderunitdocid", id);
// };

// export const getDocumentId = () => {
//   const id = localStorage.getItem("traderunitdocid");
//   if (id !== null && id !== undefined) {
//     return id;
//   } else {
//     return null;
//   }
// };
// export const removeDocumentId = () => {
//   localStorage.removeItem("traderunitdocid");
// };

// export const setTraderSelectedUnit = (unit) => {
//   localStorage.setItem("traderselectedunit", unit);
// };

// export const getTraderSelectedUnit = () => {
//   const traderUnit = localStorage.getItem("traderselectedunit");
//   if (traderUnit !== null && traderUnit !== undefined) {
//     return traderUnit;
//   } else {
//     return null;
//   }
// };
// export const removeTraderSelectedUnit = () => {
//   localStorage.removeItem("traderselectedunit");
// };
